import { getExpensesAnalysis } from "@/api/financialReport";
import { createAnalysisModule } from "./utils/createAnalysisModule";

// Drill-down de Análisis de Gastos para un mes específico. El tab Gastos lo abre
// al clickear una celda mensual de la tabla de evolución. Comparte shape con
// costsAnalysis (statement jerárquico + ranking de contrapartes); la única
// diferencia de datos es que el statement de Gastos expone `efficiency` por
// grupo (gasto/ventas) en lugar de `margin`. La mecánica vive en
// createAnalysisModule.
export default createAnalysisModule({
    apiFn: getExpensesAnalysis,
    fetchActionName: "fetchExpensesAnalysis",
    logPrefix: "[expensesAnalysis]",
    errorMessage: "Error al cargar el análisis de gastos.",
});
